import { render } from "./CommentActivityView.vue?vue&type=template&id=895d35b0&scoped=true"
import script from "./CommentActivityView.vue?vue&type=script&lang=js"
export * from "./CommentActivityView.vue?vue&type=script&lang=js"

import "./CommentActivityView.vue?vue&type=style&index=0&id=895d35b0&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-895d35b0"]])

export default __exports__